import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';

const calendarTableconfig = {
  plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
  headerToolbar: {
    left: '',
    center: '',
    right: ''
  },
  slotLabelFormat: [
    {
      hour: 'numeric'
    }
  ],
  initialView: 'timeGridWeek',
  selectable: true,
  dayMaxEventRows: true,
  views: {
    dayGridMonth: {
      dayMaxEventRows: 4
    }
  },
  eventTimeFormat: {
    hour: '2-digit',
    minute: '2-digit'
  },
  nowIndicator: true
};

export default calendarTableconfig;
